export { CustomerReviews } from "./lib/customer-reviews";
export { getStaticProps } from "./lib/get-static-props";
